/* eslint-disable */ import { memoEval, sceneEntityRemoteObjectComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const evoBaseW36Components = [
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'body', true).withEntity('EvoBaseW36').attach(memoEval(()=>[], ()=>({
            fileUrl: '/models/jms.glb',
            objectName: 'CABINET_LYNX_EVO36_BODY',
            dimensionUnit: 'inch'
        })))
];

//# sourceMappingURL=evo-base-w-36.js.map